// @flow

import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

// Root Reducer
import reducers from "./../reducers";

const composeEnhancers =
  (process.env.NODE_ENV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));

const store = createStore(reducers, enhancer);

export { store };



// WEBPACK FOOTER //
// ./src/setup/configureStore.js